'use strict';

/*global echo*/
/*global blockElement*/
/*global unBlockElement*/
(function ($) {
  function addFile($file) {
    $file.find('.file__input').trigger('click');
  }

  function removeFile($file) {
      $file.find('.file__btn-add').text($file.find('.file__btn-add').data('title'));
      $file.find('.file__btn-add').css({ 'background-image': '' });
      $file.find('.file__value').val('');
  }

  function selectFile($fileInput, e) {
    var $file = $fileInput.closest('.file');
    var uploadCallbackName = $fileInput.data('upload_callback_name');
    var uploadRoute = $fileInput.data('upload_route');

    var fileCount = 0;
    $.each(e.target.files, function () {
      fileCount++;
    });

    blockElement($file);
    $.each(e.target.files, function (key, value) {
      var data = new FormData();
      data.append('file', value);
      data.append('file_name', $fileInput.data('file_name'));

      $.ajax({
        url: uploadRoute,
        type: 'POST',
        data: data,
        cache: false,
        dataType: 'json',
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function (res) {
          fileCount--;
          if (fileCount === 0) {
            unBlockElement($file);
          }

          if (typeof res.error === 'undefined') {
            if (uploadCallbackName) {
              var fn = window[uploadCallbackName];
              if (typeof fn === 'function') {
                fn(res, $fileInput);
              }
            } else {
              $file.find('.file__btn-add').text(res.data.name);
              $file.find('.file__value').val(res.data.file_id);
              $file.find('.file__btn-download').attr('href', res.data.file_url);
              if($file.hasClass('file--image')) {
                  $file.find('.file__btn-add').css({ 'background-image': 'url(' + res.data.file_url + ')' });
              }
            }
          }
        },

        error: function (jqXHR, textStatus) {
          fileCount--;
          if (fileCount === 0) {
            $file.find('.file__btn-add').show();
          }
        }
      });
    });

    $fileInput.val('');
  }

  var methods = {
    init: function (/*options*/) {
      // options are not used
      //var opts = $.extend({}, $.fn.File.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('file--init')) {
          return;
        }

        $this.addClass('file--init');

        $this.on('click', '.file__btn-add', function () {
          addFile($this);
          return false;
        });

        $this.on('click', '.file__btn-remove', function (e) {
          removeFile($this, e);
          return false;
        });

        $this.on('change', '.file__input', function (e) {
          selectFile($(this), e);
          return false;
        });
      });
    }
  };

  $.fn.File = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.File');
    }

  };

  $.fn.File.defaults = {};

})(jQuery);
